"use strict";
function Customer() {
    return {
        isValidFullName(fullName) {
            const target = fullName || this?.name || '';
            return target.trim().split(' ').length >= 2;
        }
    };
}
window.Customer = Customer;
//# sourceMappingURL=index.js.map